import * as React from 'react'
// import { Link } from 'react-router-dom'
import { Line, FooterWrap, LinkWrapper } from './FooterCleverStyle'

export default class FooterClever extends React.Component {
  render() {
    const year = new Date().getFullYear()

    return (
      <FooterWrap>
        <LinkWrapper>
        <a href='https://www.clever-bestattung.at/impressum/' target='_blank'>
          Impressum
          </a>
          <a href='https://www.clever-bestattung.at/datenschutz/' target='_blank'>            
            Datenschutz
          </a>
          <a href='https://www.clever-bestattung.at/agb/' target='_blank'>
            AGB
          </a>
          <a href='https://www.clever-bestattung.at/widerruf/' target='_blank'>
            Widerruf
          </a>
        </LinkWrapper>
        <Line>&copy;{year} CLEVER Bestattung. Alle Rechte vorbehalten.</Line>
      </FooterWrap>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/FooterClever.tsx